<template>
  <div class="dashboard-container">
    <!-- Imagen de fondo -->
    <div class="dashboard-background">
      <img v-if="((getProfile.role > 0 && getProfile.role < 5) || getProfile.staff === true) && getProfile.wallpaper !== null"
        :src="getProfile.wallpaper" class="background-image" />
    </div>

    <v-container class="dashboard-content" fluid fill-height>
      <!-- Diálogo modal Persistente para seleccionar la Caseta -->
      <v-dialog v-model="dialogInitial" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('selecciona_caseta') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form @submit.prevent="setGuardHouse()">
                <v-col cols="12" sm="12">
                  <v-autocomplete v-model="guardHouse" name="guardHouse" :items="guardHouses" item-text="name"
                    item-value="id" :label="$t('Casetas')" autocomplete="off"></v-autocomplete>
                </v-col>
                <v-btn color="primary" type="submit">{{ $t('aceptar') }}
                </v-btn>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <h1 class="white--text mb-4 text-center" style="width: 100%">{{ $t('Bienvenido') }}: {{ getProfile.first_name }}
        {{ getProfile.last_name }}</h1>

      <!-- Dashboard en tres columnas para administrador general -->
      <v-row v-if="showGeneralAdminDashboard" justify="center" class="dashboard-row">
        <!-- Columna 1: Panel de Ocupación -->
        <v-col cols="12" md="4">
          <!-- Total del Día (Movido arriba) -->
          <v-card class="mb-4 rounded-lg elevation-1">
            <div class="d-flex align-center justify-space-between pa-4">
              <div class="d-flex align-center">
                <v-avatar color="grey lighten-4" size="40" class="mr-3">
                  <v-icon color="grey darken-1" small>mdi-calendar-today</v-icon>
                </v-avatar>
                <div class="font-weight-medium grey--text text--darken-2">{{ $t('total_del_dia') }}</div>
              </div>
              <div class="text-h5 font-weight-bold grey--text text--darken-3">{{ occupancy.todayTotal }}</div>
            </div>
          </v-card>

          <v-card class="elevation-2 dashboard-card rounded-lg">
            <div class="d-flex align-center pa-4">
              <v-avatar color="primary lighten-5" size="40" class="mr-3">
                <v-icon color="primary" small>mdi-account-group</v-icon>
              </v-avatar>
              <h3 class="text-h6 font-weight-bold primary--text mb-0">{{ $t('ocupacion_club') }}</h3>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-4">
              <v-row align="center">
                <!-- Columna Izquierda: Gráfica Circular -->
                <v-col cols="12" md="5" class="text-center">
                  <v-progress-circular :rotate="-90" :size="gaugeSize" :width="gaugeWidth" :value="occupancyPercentage"
                    :color="occupancyColor">
                    <div class="d-flex flex-column align-center">
                      <span class="display-1 font-weight-bold grey--text text--darken-3">{{ totalCurrent }}</span>
                      <span class="caption grey--text">/ {{ occupancy.capacity }}</span>
                      <span class="subtitle-1 font-weight-medium" :class="occupancyColor + '--text'">
                        {{ occupancyPercentage.toFixed(1) }}%
                      </span>
                    </div>
                  </v-progress-circular>
                  <div class="mt-3 subtitle-1 grey--text">
                    {{ $t('capacidad_maxima') }}: {{ occupancy.capacity }} {{ $t('personas') }}
                  </div>
                </v-col>

                <!-- Columna Derecha: Lista de Categorías -->
                <v-col cols="12" md="7">
                  <div class="occupancy-list">
                    <div class="d-flex align-center justify-space-between mb-3">
                      <div class="d-flex align-center">
                        <v-icon color="primary" class="mr-3">mdi-account-star</v-icon>
                        <span class="body-1">{{ $t('socios') }}</span>
                      </div>
                      <span class="font-weight-bold title">{{ occupancy.current.socios }}</span>
                    </div>

                    <div class="d-flex align-center justify-space-between mb-3">
                      <div class="d-flex align-center">
                        <v-icon color="success" class="mr-3">mdi-badge-account</v-icon>
                        <span class="body-1">{{ $t('empleados_ocupacion') }}</span>
                      </div>
                      <span class="font-weight-bold title">{{ occupancy.current.empleados }}</span>
                    </div>

                    <div class="d-flex align-center justify-space-between mb-3">
                      <div class="d-flex align-center">
                        <v-icon color="warning" class="mr-3">mdi-truck-delivery</v-icon>
                        <span class="body-1">{{ $t('proveedores') }}</span>
                      </div>
                      <span class="font-weight-bold title">{{ occupancy.current.proveedores }}</span>
                    </div>

                    <div class="d-flex align-center justify-space-between mb-3">
                      <div class="d-flex align-center">
                        <v-icon color="info" class="mr-3">mdi-account-multiple</v-icon>
                        <span class="body-1">{{ $t('invitados') }}</span>
                      </div>
                      <span class="font-weight-bold title">{{ occupancy.current.invitados }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Línea de separación y Total como suma -->
              <v-divider class="my-4"></v-divider>
              <div class="d-flex align-center justify-space-between">
                <span class="text-h6 font-weight-bold grey--text text--darken-2">{{ $t('total_actual') }}</span>
                <v-chip :color="occupancyColor" dark label class="text-h5 font-weight-bold px-4 py-3"
                  style="height: auto;">
                  {{ totalCurrent }}
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Columna 2: Gráfica de Ingresos -->
        <v-col cols="12" md="4">
          <v-card class="elevation-2 dashboard-card rounded-lg" style="height: 100%">
            <div class="d-flex align-center justify-space-between pa-4">
              <div class="d-flex align-center">
                <v-avatar color="primary lighten-5" size="40" class="mr-3">
                  <v-icon color="primary" small>mdi-chart-line</v-icon>
                </v-avatar>
                <h3 class="text-h6 font-weight-bold primary--text mb-0">{{ $t('ingresos_por_dia') }}</h3>
              </div>

              <v-btn-toggle v-model="chartFilter" mandatory dense rounded class="elevation-0">
                <v-btn small value="week" text color="primary">
                  {{ $t('semana') }}
                </v-btn>
                <v-btn small value="month" text color="primary">
                  {{ $t('mes') }}
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
              <!-- Selector de fechas personalizado -->
              <v-row v-if="chartFilter === 'custom'" class="mb-4">
                <v-col cols="12" sm="5">
                  <v-menu v-model="menuStartDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="startDate" :label="$t('fecha_inicio')" prepend-icon="mdi-calendar" readonly
                        dense outlined v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" @input="menuStartDate = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="5">
                  <v-menu v-model="menuEndDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="endDate" :label="$t('fecha_fin')" prepend-icon="mdi-calendar" readonly
                        dense outlined v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="endDate" @input="menuEndDate = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex align-center">
                  <v-btn color="primary" small @click="applyCustomFilter">
                    {{ $t('aplicar') }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Gráfica -->
              <div class="chart-container">
                <canvas ref="incomeChart"></canvas>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Columna 3: Estadísticas de Golf -->
        <v-col cols="12" md="4">
          <v-card class="elevation-2 dashboard-card rounded-lg" style="height: 100%">
            <div class="d-flex align-center justify-space-between pa-3">
              <div class="d-flex align-center">
                <v-avatar color="primary lighten-5" size="36" class="mr-2">
                  <v-icon color="primary" small>mdi-golf</v-icon>
                </v-avatar>
                <h3 class="text-subtitle-1 font-weight-bold primary--text mb-0">{{ $t('estadisticas_golf') }}</h3>
              </div>
              <v-btn-toggle v-model="golfChartFilter" mandatory dense rounded class="elevation-0">
                <v-btn x-small value="day" text color="primary">
                  {{ $t('dia') || 'Día' }}
                </v-btn>
                <v-btn x-small value="week" text color="primary">
                  {{ $t('semana') }}
                </v-btn>
                <v-btn x-small value="month" text color="primary">
                  {{ $t('mes') }}
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-3">
              <!-- Estadísticas Rápidas compactas -->
              <v-row class="mb-2" dense>
                <v-col cols="6">
                  <v-card flat class="rounded-lg" color="primary lighten-5">
                    <v-card-text class="pa-2 text-center">
                      <v-icon color="primary" x-small class="mb-1">mdi-calendar-check</v-icon>
                      <div class="text-caption font-weight-medium primary--text text-truncate">{{ $t('total_reservaciones') || 'Total' }}</div>
                      <div class="text-subtitle-1 font-weight-bold primary--text">{{ golfStats.totalReservations }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card flat class="rounded-lg" color="green lighten-5">
                    <v-card-text class="pa-2 text-center">
                      <v-icon color="success" x-small class="mb-1">mdi-check-circle</v-icon>
                      <div class="text-caption font-weight-medium success--text text-truncate">{{ $t('completadas') || 'Completadas' }}</div>
                      <div class="text-subtitle-1 font-weight-bold success--text">{{ golfStats.completed }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card flat class="rounded-lg" color="orange lighten-5">
                    <v-card-text class="pa-2 text-center">
                      <v-icon color="warning" x-small class="mb-1">mdi-clock-outline</v-icon>
                      <div class="text-caption font-weight-medium warning--text text-truncate">{{ $t('pendientes') || 'Pendientes' }}</div>
                      <div class="text-subtitle-1 font-weight-bold warning--text">{{ golfStats.pending }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card flat class="rounded-lg" color="red lighten-5">
                    <v-card-text class="pa-2 text-center">
                      <v-icon color="error" x-small class="mb-1">mdi-cancel</v-icon>
                      <div class="text-caption font-weight-medium error--text text-truncate">{{ $t('canceladas') || 'Canceladas' }}</div>
                      <div class="text-subtitle-1 font-weight-bold error--text">{{ golfStats.cancelled }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card flat class="rounded-lg" color="blue lighten-5">
                    <v-card-text class="pa-2 text-center">
                      <v-icon color="info" x-small class="mb-1">mdi-account-group</v-icon>
                      <div class="text-caption font-weight-medium info--text text-truncate">{{ $t('jugadores_totales') || 'Jugadores' }}</div>
                      <div class="text-subtitle-1 font-weight-bold info--text">{{ golfStats.totalPlayers }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Gráfica de Reservaciones -->
              <div class="chart-container-small">
                <canvas ref="golfChart"></canvas>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Card de Estadísticas de Golf para roles con acceso a golf sin panel general -->
      <v-row v-if="showStandaloneGolfStats" justify="center" class="dashboard-row">
        <v-col cols="12" md="10" lg="8">
          <v-card class="elevation-2 dashboard-card rounded-lg">
            <div class="d-flex align-center justify-space-between pa-4">
              <div class="d-flex align-center">
                <v-avatar color="primary lighten-5" size="40" class="mr-3">
                  <v-icon color="primary" small>mdi-golf</v-icon>
                </v-avatar>
                <h3 class="text-h6 font-weight-bold primary--text mb-0">{{ $t('estadisticas_golf') }}</h3>
              </div>
              <v-btn-toggle v-model="golfChartFilter" mandatory dense rounded class="elevation-0">
                <v-btn small value="day" text color="primary">
                  {{ $t('dia') || 'Día' }}
                </v-btn>
                <v-btn small value="week" text color="primary">
                  {{ $t('semana') }}
                </v-btn>
                <v-btn small value="month" text color="primary">
                  {{ $t('mes') }}
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-4">
              <v-row>
                <!-- Estadísticas Rápidas -->
                <v-col cols="12">
                  <v-row class="mb-2" dense>
                    <v-col cols="6" sm="4" md>
                      <v-card flat class="fill-height rounded-lg" color="primary lighten-5">
                        <v-card-text class="pa-2 text-center">
                          <v-icon color="primary" small class="mb-1">mdi-calendar-check</v-icon>
                          <div class="text-caption font-weight-medium primary--text text-truncate">{{
                            $t('total_reservaciones') || 'Total' }}</div>
                          <div class="text-h6 font-weight-bold primary--text">{{ golfStats.totalReservations }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="6" sm="4" md>
                      <v-card flat class="fill-height rounded-lg" color="green lighten-5">
                        <v-card-text class="pa-2 text-center">
                          <v-icon color="success" small class="mb-1">mdi-check-circle</v-icon>
                          <div class="text-caption font-weight-medium success--text text-truncate">{{ $t('completadas')
                            ||
                            'Completadas' }}</div>
                          <div class="text-h6 font-weight-bold success--text">{{ golfStats.completed }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="6" sm="4" md>
                      <v-card flat class="fill-height rounded-lg" color="orange lighten-5">
                        <v-card-text class="pa-2 text-center">
                          <v-icon color="warning" small class="mb-1">mdi-clock-outline</v-icon>
                          <div class="text-caption font-weight-medium warning--text text-truncate">{{ $t('pendientes')
                            ||
                            'Pendientes' }}</div>
                          <div class="text-h6 font-weight-bold warning--text">{{ golfStats.pending }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="6" sm="4" md>
                      <v-card flat class="fill-height rounded-lg" color="red lighten-5">
                        <v-card-text class="pa-2 text-center">
                          <v-icon color="error" small class="mb-1">mdi-cancel</v-icon>
                          <div class="text-caption font-weight-medium error--text text-truncate">{{ $t('canceladas') ||
                            'Canceladas' }}</div>
                          <div class="text-h6 font-weight-bold error--text">{{ golfStats.cancelled }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="6" sm="4" md>
                      <v-card flat class="fill-height rounded-lg" color="blue lighten-5">
                        <v-card-text class="pa-2 text-center">
                          <v-icon color="info" small class="mb-1">mdi-account-group</v-icon>
                          <div class="text-caption font-weight-medium info--text text-truncate">{{
                            $t('jugadores_totales') ||
                            'Jugadores' }}</div>
                          <div class="text-h6 font-weight-bold info--text">{{ golfStats.totalPlayers }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- Gráfica de Reservaciones -->
                <v-col cols="12" md="8">
                  <div class="chart-container">
                    <canvas ref="golfChartAlt"></canvas>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Dashboard para Profesores -->
      <v-row v-if="showTeacherDashboard" justify="center" class="dashboard-row mt-6">
        <v-col cols="12" md="12" lg="10">
          <v-card class="elevation-2 dashboard-card rounded-lg">
            <!-- Header -->
            <div class="d-flex align-center justify-space-between pa-6">
              <div class="d-flex align-center">
                <v-avatar :color="teacherOccupancyColor" size="56" class="mr-4">
                  <v-icon color="white" size="32">mdi-dumbbell</v-icon>
                </v-avatar>
                <div>
                  <h3 class="text-h5 font-weight-bold grey--text text--darken-3 mb-0">
                    {{ teacherArea?.areaName || 'Mi Área' }}
                  </h3>
                  <div class="text-subtitle-1 grey--text">
                    {{ teacherArea?.position || 'Profesor' }}
                  </div>
                </div>
              </div>
              <v-btn
                icon
                small
                @click="loadTeacherData()"
                :loading="loadingTeacherData"
              >
                <v-icon small color="grey">mdi-refresh</v-icon>
              </v-btn>
            </div>

            <v-divider></v-divider>

            <!-- Content -->
            <v-card-text class="pa-6">
              <v-row dense class="mb-4">
                <!-- Ocupación actual -->
                <v-col cols="12">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <span class="text-subtitle-1 font-weight-medium grey--text">Ocupación Actual</span>
                    <v-chip
                      :color="teacherOccupancyColor"
                      dark
                      x-small
                      class="font-weight-bold text-h6"
                    >
                      {{ teacherOccupancy ? (teacherOccupancy.occupancy_level * 100).toFixed(0) : 0 }}%
                    </v-chip>
                  </div>
                  <v-progress-linear
                    :value="teacherOccupancy ? (teacherOccupancy.occupancy_level * 100) : 0"
                    :color="teacherOccupancyColor"
                    background-color="grey lighten-3"
                    height="14"
                    rounded
                    class="mb-2"
                  ></v-progress-linear>
                </v-col>

                <!-- Contador de personas -->
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6" sm="4">
                      <v-card flat class="rounded-lg" :color="teacherOccupancyColor + ' lighten-5'">
                        <v-card-text class="pa-4 text-center">
                          <v-icon :color="teacherOccupancyColor" class="mb-2">mdi-account</v-icon>
                          <div class="text-subtitle-2 font-weight-medium" :style="`color: ${teacherOccupancyColor};`">Presentes</div>
                          <div class="text-h4 font-weight-bold" :style="`color: ${teacherOccupancyColor};`">
                            {{ teacherOccupancy?.current_count || 0 }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="6" sm="4">
                      <v-card flat class="rounded-lg" color="grey lighten-5">
                        <v-card-text class="pa-4 text-center">
                          <v-icon color="grey" class="mb-2">mdi-door-open</v-icon>
                          <div class="text-subtitle-2 font-weight-medium grey--text">Capacidad</div>
                          <div class="text-h4 font-weight-bold grey--text text--darken-1">
                            {{ teacherOccupancy?.max_capacity || '—' }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-card flat class="rounded-lg" color="blue lighten-5">
                        <v-card-text class="pa-4 text-center">
                          <v-icon color="info" size="32" class="mb-2">{{ teacherOccupancyStatusIcon }}</v-icon>
                          <div class="text-subtitle-2 font-weight-medium info--text text-truncate">
                            {{ teacherOccupancy?.status || 'N/A' }}
                          </div>
                          <div class="text-h6 font-weight-bold info--text">
                            {{ teacherOccupancy?.status === 'low' ? 'Baja' : teacherOccupancy?.status === 'medium' ? 'Media' : 'Alta' }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Botón de acceso a check-in -->
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    x-large
                    block
                    depressed
                    @click="$router.push({ name: 'area_checkin', params: { areaId: teacherArea?.idArea } })"
                  >
                    <v-icon left>mdi-account-check</v-icon>
                    Ver Panel de Check-in
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Link a Mis Áreas -->
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-btn
                    text
                    depressed
                    block
                    color="primary"
                    :to="`/teacher/my-areas`"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Ver todas mis áreas
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Dashboard de Ocupación de Áreas Deportivas para roles con acceso a deportes -->
      <v-row v-if="showSportsOccupancy" justify="center" class="dashboard-row mt-6">
        <v-col cols="12">
          <v-card class="elevation-2 dashboard-card rounded-lg">
            <div class="d-flex align-center justify-space-between pa-4">
              <div class="d-flex align-center">
                <v-avatar color="primary lighten-5" size="40" class="mr-3">
                  <v-icon color="primary" small>mdi-map-marker-radius</v-icon>
                </v-avatar>
                <h3 class="text-h6 font-weight-bold primary--text mb-0">{{ $t('sports_areas_occupancy') || 'Ocupación de Áreas Deportivas' }}</h3>
              </div>
              <v-btn v-if="sportsAreas.length > 0" icon small @click="fetchSportsAreas" :loading="loadingSportsAreas">
                <v-icon small color="grey">mdi-refresh</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-4">
              <v-row v-if="loadingSportsAreas" justify="center" class="py-6">
                <v-progress-circular indeterminate color="warning" size="40"></v-progress-circular>
              </v-row>

              <div v-else-if="sportsAreas.length === 0" class="text-center grey--text py-6">
                <v-icon large color="grey lighten-2">mdi-map-marker-off</v-icon>
                <div class="caption mt-2">{{ $t('no_sports_areas') || 'No hay áreas configuradas' }}</div>
              </div>

              <v-row v-else dense justify="center">
                <v-col v-for="area in sportsAreas" :key="area.area_id" cols="12" sm="6" md="6">
                  <v-card
                    class="area-occ-card rounded-xl"
                    elevation="1"
                    style="cursor: pointer; overflow: hidden; transition: box-shadow 0.25s ease, transform 0.2s ease;"
                    @click="goToArea(area)"
                  >
                    <div :style="`height: 5px; background: ${area.hexColor};`"></div>

                    <v-card-text class="pa-3">
                      <div class="d-flex align-center justify-space-between mb-3">
                        <div class="d-flex align-center">
                          <v-avatar :style="`background-color: ${area.hexColor}20;`" size="36" class="mr-2">
                            <v-icon :color="area.hexColor" small>{{ getMdiIcon(area.area_name) }}</v-icon>
                          </v-avatar>
                          <div>
                            <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 text-truncate" style="max-width: 120px;">
                              {{ area.area_name }}
                            </div>
                            <div class="text-caption grey--text">
                              Cap. máx: {{ area.max_capacity }}
                            </div>
                          </div>
                        </div>
                        <v-chip
                          :color="area.hexColor"
                          dark
                          x-small
                          class="font-weight-bold"
                        >
                          {{ (area.occupancy_level * 100).toFixed(0) }}%
                        </v-chip>
                      </div>

                      <div class="d-flex align-baseline mb-2">
                        <span class="text-h4 font-weight-bold" :style="`color: ${area.hexColor};`">
                          {{ area.current_count }}
                        </span>
                        <span class="text-caption grey--text ml-1">/ {{ area.max_capacity }} personas</span>
                      </div>

                      <v-progress-linear
                        :value="area.occupancy_level * 100"
                        :color="area.hexColor"
                        background-color="grey lighten-3"
                        height="8"
                        rounded
                        class="mb-2"
                      ></v-progress-linear>

                      <div class="d-flex align-center">
                        <v-icon x-small :color="area.hexColor" class="mr-1">{{ getAreaStatusIcon(area.status) }}</v-icon>
                        <span class="text-caption font-weight-medium" :style="`color: ${area.hexColor};`">
                          {{ getAreaStatusLabel(area.status) }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-icon x-small color="grey lighten-1">mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Handicap Stats - Golf Admin/RP -->
      <v-row v-if="isGolfUser" justify="center" class="dashboard-row mt-6">
        <v-col cols="12" md="6">
          <v-card class="elevation-2 dashboard-card rounded-lg">
            <div class="d-flex align-center justify-space-between pa-4">
              <div class="d-flex align-center">
                <v-avatar color="green lighten-5" size="40" class="mr-3">
                  <v-icon color="green" small>mdi-golf</v-icon>
                </v-avatar>
                <h3 class="text-h6 font-weight-bold green--text mb-0">Mi Handicap</h3>
              </div>
            </div>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
              <v-row v-if="handicapLoading" class="justify-center py-6">
                <v-progress-circular indeterminate color="green"></v-progress-circular>
              </v-row>
              <v-row v-else>
                <v-col cols="12" sm="6" class="text-center">
                  <div class="text-caption grey--text text--darken-1 mb-1">Mi Handicap Actual</div>
                  <div class="display-2 font-weight-bold green--text">
                    {{ myHandicap?.value || '-' }}
                  </div>
                  <div class="text-caption grey--text mt-2" v-if="myHandicap?.lastUpdate">
                    Actualizado: {{ formatDate(myHandicap.lastUpdate) }}
                  </div>
                </v-col>
                <v-col cols="12" sm="6" class="text-center">
                  <div class="text-caption grey--text text--darken-1 mb-1">Promedio Club</div>
                  <div class="display-2 font-weight-bold blue--text">
                    {{ clubAverage || '-' }}
                  </div>
                  <div class="text-caption grey--text mt-2">
                    {{ handicapComparison }}
                  </div>
                </v-col>
              </v-row>
              <v-divider class="my-3" v-if="!handicapLoading"></v-divider>
              <v-row v-if="!handicapLoading" class="justify-center">
                <v-btn
                  small
                  color="green"
                  text
                  to="/golf/handicaps"
                >
                  Ver Detalles
                </v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Upcoming Reservations with Agreements -->
        <v-col cols="12" md="6">
          <v-card class="elevation-2 dashboard-card rounded-lg">
            <div class="d-flex align-center justify-space-between pa-4">
              <div class="d-flex align-center">
                <v-avatar color="purple lighten-5" size="40" class="mr-3">
                  <v-icon color="purple" small>mdi-calendar-check</v-icon>
                </v-avatar>
                <h3 class="text-h6 font-weight-bold purple--text mb-0">Próximas Salidas con Convenio</h3>
              </div>
            </div>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
              <v-row v-if="upcomingReservationsLoading" class="justify-center py-6">
                <v-progress-circular indeterminate color="purple"></v-progress-circular>
              </v-row>
              <div v-else-if="upcomingReservationsWithAgreement.length === 0" class="text-center py-6 grey--text">
                No hay salidas próximas con convenio
              </div>
              <v-list v-else dense>
                <v-list-item
                  v-for="reservation in upcomingReservationsWithAgreement.slice(0, 3)"
                  :key="reservation.id"
                  class="px-0"
                >
                  <v-list-item-icon class="mr-3 mt-0">
                    <v-icon small color="purple">mdi-golf</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold text-truncate">
                      {{ reservation.course_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption">
                      {{ formatDate(reservation.date_played) }}
                      • {{ reservation.hour }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action-text class="text-right">
                    <v-chip x-small color="purple" text-color="white" label>
                      {{ reservation.agreement_type }}
                    </v-chip>
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
              <v-divider class="my-3" v-if="upcomingReservationsWithAgreement.length > 0"></v-divider>
              <v-row v-if="upcomingReservationsWithAgreement.length > 0" class="justify-center">
                <v-btn
                  small
                  color="purple"
                  text
                  to="/golf/reservations"
                >
                  Ver Todas
                </v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import axios from 'axios'
import store from '@/store'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default {
  name: 'home',
  components: {
  },
  data () {
    return {
      dialogInitial: false,
      guardHouse: null,
      guardHouses: [],
      role: 0,
      bandDevices: true,
      devices: [],
      cams: [],
      qrs: [],
      // Datos de ocupación del club
      occupancy: {
        capacity: 400,
        current: {
          socios: 125,
          empleados: 45,
          proveedores: 18,
          invitados: 12
        },
        todayTotal: 347
      },
      // Datos para la gráfica
      chartFilter: 'week',
      menuStartDate: false,
      menuEndDate: false,
      startDate: null,
      endDate: null,
      // Datos de ingresos por día
      weeklyData: {
        labels: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        socios: [156, 142, 138, 165, 189, 245, 218],
        empleados: [52, 55, 48, 54, 51, 42, 38],
        proveedores: [28, 32, 45, 38, 42, 12, 8],
        invitados: [18, 22, 15, 28, 56, 124, 98]
      },
      monthlyData: {
        labels: ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4'],
        socios: [892, 945, 1024, 978],
        empleados: [312, 328, 305, 298],
        proveedores: [156, 172, 148, 135],
        invitados: [245, 312, 378, 342]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 20,
              font: {
                size: 12
              }
            }
          },
          tooltip: {
            backgroundColor: 'rgba(42, 39, 56, 0.9)',
            titleFont: { size: 14 },
            bodyFont: { size: 13 },
            padding: 12,
            cornerRadius: 8
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        }
      },
      // Datos para estadísticas de Golf
      golfChartFilter: 'week',
      golfStats: {
        totalReservations: 156,
        completed: 124,
        pending: 18,
        cancelled: 14,
        totalPlayers: 498
      },
      golfDailyData: {
        labels: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'],
        reservaciones: [3, 5, 4, 6, 2, 4, 7, 5, 3, 2],
        jugadores: [12, 18, 14, 22, 8, 15, 26, 18, 11, 7]
      },
      golfWeeklyData: {
        labels: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        reservaciones: [12, 15, 18, 22, 28, 35, 26],
        jugadores: [42, 52, 64, 78, 98, 124, 92]
      },
      golfMonthlyData: {
        labels: ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4'],
        reservaciones: [85, 92, 105, 98],
        jugadores: [298, 324, 378, 356]
      },
      golfChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 20
            }
          },
          tooltip: {
            backgroundColor: 'rgba(42, 39, 56, 0.9)',
            padding: 12,
            cornerRadius: 8
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        }
      },
      // Chart Instances
      incomeChartInstance: null,
      golfChartInstance: null,
      // Datos de áreas deportivas
      sportsAreas: [],
      loadingSportsAreas: false,
      // Datos para profesores
      teacherArea: null,
      teacherOccupancy: null,
      loadingTeacherData: false,
      updateTeacherInterval: null,
      // Datos de handicaps
      myHandicap: null,
      clubAverage: null,
      handicapLoading: false,
      // Próximas salidas con convenios
      upcomingReservationsWithAgreement: [],
      upcomingReservationsLoading: false
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    permissions () {
      return Array.isArray(this.getProfile.permissions) ? this.getProfile.permissions : []
    },
    isAdminRole () {
      return this.role === 1
    },
    hasGolfPermissions () {
      return this.permissions.includes('starter') || this.permissions.includes('golf_admin') || this.permissions.includes('golf_public_relations')
    },
    hasSportsPermissions () {
      return this.permissions.includes('sports') && !this.permissions.includes('golf_public_relations')
    },
    hasTeacherPermissions () {
      return this.getProfile.staff === true
    },
    hasSpecializedAdminPermissions () {
      return this.hasGolfPermissions || this.hasSportsPermissions
    },
    showGeneralAdminDashboard () {
      return this.isAdminRole && !this.hasSpecializedAdminPermissions
    },
    showGolfStats () {
      return this.isAdminRole && (this.showGeneralAdminDashboard || this.hasGolfPermissions)
    },
    showStandaloneGolfStats () {
      return this.showGolfStats && !this.showGeneralAdminDashboard
    },
    showSportsOccupancy () {
      return this.isAdminRole && (this.showGeneralAdminDashboard || this.hasSportsPermissions)
    },
    showTeacherDashboard () {
      return this.hasTeacherPermissions && this.teacherArea !== null
    },
    totalCurrent () {
      return this.occupancy.current.socios +
        this.occupancy.current.empleados +
        this.occupancy.current.proveedores +
        this.occupancy.current.invitados
    },
    occupancyPercentage () {
      return (this.totalCurrent / this.occupancy.capacity) * 100
    },
    occupancyColor () {
      if (this.occupancyPercentage >= 90) return 'red'
      if (this.occupancyPercentage >= 70) return 'orange'
      if (this.occupancyPercentage >= 50) return 'yellow darken-2'
      return 'green'
    },
    teacherOccupancyColor () {
      if (!this.teacherOccupancy) return 'grey'
      const percent = this.teacherOccupancy.occupancy_level * 100 || 0
      if (percent >= 90) return 'red'
      if (percent >= 70) return 'orange'
      if (percent >= 50) return 'yellow darken-2'
      return 'green'
    },
    teacherOccupancyStatusIcon () {
      if (!this.teacherOccupancy) return 'mdi-help-circle'
      switch (this.teacherOccupancy.status) {
        case 'low': return 'mdi-check-circle'
        case 'medium': return 'mdi-alert-circle'
        case 'high': return 'mdi-alert-circle-outline'
        default: return 'mdi-help-circle'
      }
    },
    gaugeSize () {
      if (this.$vuetify.breakpoint.xsOnly) return 120
      if (this.$vuetify.breakpoint.smOnly) return 140
      return 160
    },
    gaugeWidth () {
      if (this.$vuetify.breakpoint.xsOnly) return 12
      if (this.$vuetify.breakpoint.smOnly) return 14
      return 16
    },
    chartData () {
      const data = this.chartFilter === 'month' ? this.monthlyData : this.weeklyData
      return {
        labels: data.labels,
        datasets: [
          {
            label: this.$t('socios'),
            borderColor: '#2a2738',
            backgroundColor: 'rgba(42, 39, 56, 0.1)',
            data: data.socios,
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#2a2738',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 4
          },
          {
            label: this.$t('empleados_ocupacion'),
            borderColor: '#776F9B',
            backgroundColor: 'rgba(119, 111, 155, 0.1)',
            data: data.empleados,
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#776F9B',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 4
          },
          {
            label: this.$t('proveedores'),
            borderColor: '#F9A825',
            backgroundColor: 'rgba(249, 168, 37, 0.1)',
            data: data.proveedores,
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#F9A825',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 4
          },
          {
            label: this.$t('invitados'),
            borderColor: '#26A69A',
            backgroundColor: 'rgba(38, 166, 154, 0.1)',
            data: data.invitados,
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#26A69A',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 4
          }
        ]
      }
    },
    golfChartData () {
      let data
      if (this.golfChartFilter === 'day') {
        data = this.golfDailyData
      } else if (this.golfChartFilter === 'month') {
        data = this.golfMonthlyData
      } else {
        data = this.golfWeeklyData
      }
      return {
        labels: data.labels,
        datasets: [
          {
            label: this.$t('reservaciones') || 'Reservaciones',
            borderColor: '#2a2738',
            backgroundColor: 'rgba(42, 39, 56, 0.15)',
            data: data.reservaciones,
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#2a2738',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 5,
            borderWidth: 3
          },
          {
            label: this.$t('jugadores') || 'Jugadores',
            borderColor: '#26A69A',
            backgroundColor: 'rgba(38, 166, 154, 0.15)',
            data: data.jugadores,
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#26A69A',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 5,
            borderWidth: 3
          }
        ]
      }
    },
    isGolfUser () {
      return this.getProfile?.is_staff === true ||
             this.getProfile?.is_superuser === true ||
             this.getProfile?.permissions?.includes('golf_public_relations')
    },
    handicapComparison () {
      if (!this.myHandicap || !this.clubAverage) return ''
      const diff = this.myHandicap.value - this.clubAverage
      if (diff < 0) return `Mejor que promedio (${Math.abs(diff).toFixed(1)})`
      if (diff > 0) return `Inferior al promedio (+${diff.toFixed(1)})`
      return 'Igual al promedio'
    }
  },
  watch: {
    chartFilter () {
      this.updateIncomeChart()
    },
    golfChartFilter () {
      this.updateGolfChart()
    }
  },
  mounted () {
    // Las gráficas se inicializan en getExtraData() después de obtener el rol del usuario
    this.getExtraData()

    // Si es profesor, cargar datos del profesor
    if (this.hasTeacherPermissions) {
      this.loadTeacherData()
      // Actualizar cada 30 segundos
      this.updateTeacherInterval = setInterval(() => {
        this.loadTeacherData()
      }, 30000)
    }

    // Si es usuario de golf, cargar datos de handicap y próximas salidas
    if (this.isGolfUser) {
      this.loadHandicapData()
      this.loadUpcomingReservationsWithAgreement()
    }
  },
  beforeDestroy () {
    if (this.incomeChartInstance) {
      this.incomeChartInstance.destroy()
    }
    if (this.golfChartInstance) {
      this.golfChartInstance.destroy()
    }
    if (this.updateTeacherInterval) {
      clearInterval(this.updateTeacherInterval)
      this.updateTeacherInterval = null
    }
  },
  methods: {
    initIncomeChart () {
      const ctx = this.$refs.incomeChart
      if (ctx) {
        if (this.incomeChartInstance) {
          this.incomeChartInstance.destroy()
        }
        this.incomeChartInstance = new Chart(ctx, {
          type: 'line',
          data: this.chartData,
          options: this.chartOptions
        })
      }
    },
    updateIncomeChart () {
      if (this.incomeChartInstance) {
        this.incomeChartInstance.data = this.chartData
        this.incomeChartInstance.update()
      } else {
        this.initIncomeChart()
      }
    },
    initGolfChart () {
      // Intentar usar golfChart (para isFullAdmin) o golfChartAlt (para admin con permisos golf)
      const ctx = this.$refs.golfChart || this.$refs.golfChartAlt
      if (ctx) {
        if (this.golfChartInstance) {
          this.golfChartInstance.destroy()
        }
        this.golfChartInstance = new Chart(ctx, {
          type: 'line',
          data: this.golfChartData,
          options: this.golfChartOptions
        })
      }
    },
    updateGolfChart () {
      if (this.golfChartInstance) {
        this.golfChartInstance.data = this.golfChartData
        this.golfChartInstance.update()
      } else {
        this.initGolfChart()
      }
    },
    applyCustomFilter () {
      // Aquí se implementará la lógica para filtrar por rango de fechas personalizado
      // Por ahora usa los datos semanales como ejemplo
      console.log('Filtro personalizado aplicado:', this.startDate, '-', this.endDate)
      this.updateIncomeChart()
    },
    getExtraData () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/users/me/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.role = response.data.role
          const permissions = Array.isArray(response.data.permissions) ? response.data.permissions : []
          const hasGolfPermissions = permissions.includes('starter') || permissions.includes('golf_admin') || permissions.includes('golf_public_relations')
          const hasSportsPermissions = permissions.includes('sports')
          const showGeneralAdminDashboard = this.role === 1 && !hasGolfPermissions && !hasSportsPermissions
          const showGolfStats = this.role === 1 && (showGeneralAdminDashboard || hasGolfPermissions)
          const showSportsOccupancy = this.role === 1 && (showGeneralAdminDashboard || hasSportsPermissions)

          // Una vez que tenemos el rol, si es admin se renderizan los charts correspondientes
          if (this.role === 1) {
            if (showSportsOccupancy) {
              this.fetchSportsAreas()
            }
            this.$nextTick(() => {
              if (showGolfStats) {
                this.initGolfChart()
              }
              if (showGeneralAdminDashboard) {
                this.initIncomeChart()
              }
            })
          }
          if (this.role === 4) {
            this.getGuardHouse()
            console.log(localStorage.getItem('idGuardHouse'))
            if (localStorage.getItem('idGuardHouse') === null && (localStorage.getItem('permisos') !== null && JSON.parse(localStorage.getItem('permisos')) === true)) {
              this.dialogInitial = true
              // console.log('Dialogo Enfocado')
            } else {
              if (localStorage.getItem('idGuardHouse') === null && (localStorage.getItem('permisos') === null && response.data.idHousingUnit === '898109fd-bb69-4d2f-a223-5457810e2171')) {
                this.dialogInitial = true
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async fetchSportsAreas () {
      this.loadingSportsAreas = true
      try {
        const config = {
          method: 'get',
          url: 'https://clubtest.intrare.app/area/occupancy/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }

        const response = await axios(config)
        let facilities = response.data.facilities || []

        // Filter ONLY Gimnasio and Natacion/Alberca
        facilities = facilities.filter(a => {
          const name = (a.area_name || '').toLowerCase()
          return name.includes('gimnasio') || name.includes('nataci') || name.includes('alberca') || name.includes('piscina') || name.includes('gym')
        })

        // Fetch color for each area individually as requested
        for (let i = 0; i < facilities.length; i++) {
          try {
            const areaInfo = await axios({
              method: 'get',
              url: `https://clubtest.intrare.app/area/${facilities[i].area_id}`,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            })
            facilities[i].hexColor = areaInfo.data.color || '#9E9E9E'
          } catch (e) {
            facilities[i].hexColor = '#9E9E9E'
          }

          // Assign icon based on area name if not provided
          if (!facilities[i].icon) {
            const areaName = (facilities[i].area_name || '').toLowerCase()
            if (areaName.includes('nataci') || areaName.includes('alberca') || areaName.includes('piscina') || areaName.includes('swim')) {
              facilities[i].icon = 'pool'
            } else if (areaName.includes('gimnasio') || areaName.includes('gym')) {
              facilities[i].icon = 'fitness_center'
            } else {
              facilities[i].icon = 'mdi-map-marker-radius'
            }
          }
        }

        this.sportsAreas = facilities
      } catch (error) {
        console.error('Error fetching sports areas:', error)
        this.sportsAreas = []
      } finally {
        this.loadingSportsAreas = false
      }
    },
    getGuardHouse () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/guardhouse/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guardHouses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDevicesByGuardHouse () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/guardhouse/' + localStorage.getItem('idGuardHouse') + '/devices/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.devices = response.data
          for (let i = 0; i < this.devices.length; i++) {
            if (this.devices[i].classification === 'qr') {
              this.qrs.push(this.devices[i])
            }
            if (this.devices[i].classification === 'cam') {
              this.cams.push(this.devices[i])
            }
          }
          localStorage.setItem('qr_devices', JSON.stringify(this.qrs))
          this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
          localStorage.setItem('cam_devices', JSON.stringify(this.cams))
          this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
          if (this.qrs.length > 0) {
            this.$store.commit('enableBandQr', true)
            localStorage.setItem('banderaQR', true)
          } else {
            this.$store.commit('enableBandQr', false)
            localStorage.setItem('banderaQR', false)
          }
          if (this.cams.length > 0) {
            localStorage.setItem('banderaAdditionalPerson', false)
            localStorage.setItem('banderaINEBack', false)
            localStorage.setItem('banderaCam', true)
            this.$store.commit('enableBandCam', true)
          } else {
            localStorage.setItem('banderaCam', false)
            this.$store.commit('enableBandCam', false)
          }
          // Iniciar Sesión en Socket
          this.connectToWebSocket()
        })
        .catch(error => {
          console.log(error)
        })
    },
    setGuardHouse () {
      if (this.guardHouse !== null) {
        localStorage.setItem('idGuardHouse', this.guardHouse)
        // Obtenemos Dispositivos de la Caseta (Simulado)
        this.getDevicesByGuardHouse()
        this.dialogInitial = false
      }
    },
    connectToWebSocket () {
      const websocket = new WebSocket('wss://clubtest.intrare.app/ws/socket/devices/' + localStorage.getItem('idGuardHouse') + '/?token=' + store.getters.getToken)
      websocket.onopen = this.onOpen
      websocket.onclose = this.onClose
      websocket.onmessage = this.onMessage
      websocket.onerror = this.onError
    },
    onOpen (event) {
      console.log('Connection opened.', event.data)
    },
    onClose (event) {
      console.log('Connection closed.', event.data)
      // Try and Reconnect after five seconds
      setTimeout(this.connectToWebSocket, 5000)
    },
    onMessage (event) {
      const message = JSON.parse(event.data)
      switch (message.classification) {
        case 'qr':
          const config = {
            method: 'get',
            url: 'https://clubtest.intrare.app/vigilant/qr/' + message.data,
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(response => {
            switch (response.data.type_code) {
              case 0: // Invitation
                const config2 = {
                  method: 'get',
                  url: 'https://clubtest.intrare.app/Access/Get/ByCode/' + message.data + '/',
                  headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                  }
                }
                axios(config2).then(response2 => {
                  var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                  var item = message
                  console.log(response2.data)
                  if (response.data.invitation.typeInv === 0) { // Tipo de Invitación Normal
                    if (response2.data.length > 0 && response2.data[0].dateTime_EntranceAccess != null && response2.data[0].dateTime_ExitAccess != null) {
                      // alert('Ya se completó el acceso con la invitación Correspondiente.')
                      // this.head_color = 'orange display-1 text--primary'
                      // this.errores_guard = this.$t('mensaje_acceso_completo')
                      // this.dialog_errores = true
                      console.log('COMPLETO')
                      var fullItem = Object.assign(item, { 'status': 1 })
                      console.log(fullItem)
                      aux.push(fullItem)
                      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                    } else {
                      if (response2.data.length > 0) {
                        // this.entrada = false
                        // this.salida = true
                        // this.dialog = true
                        // this.activar_camara = false
                        console.log('SALIDA')
                        var fullItem2 = Object.assign(item, { 'status': 3 })
                        var fullItem3 = Object.assign(fullItem2, { 'info': response.data })
                        var fullItemAccess = Object.assign(fullItem3, { 'access': response2.data[0].id })
                        console.log(fullItemAccess)
                        aux.push(fullItemAccess)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var fechaLocal1 = new Date(this.get_current_date())
                        const readableDate = response.data.invitation.dateInv.substring(3, 6) + response.data.invitation.dateInv.substring(0, 2) + response.data.invitation.dateInv.substring(5, 10)
                        var fechaAccesoEntrada1 = new Date(readableDate)
                        if (fechaAccesoEntrada1.getTime() !== fechaLocal1.getTime()) {
                          console.log('Fuera de FECHA')
                          var fullItem17 = Object.assign(item, { 'status': 4 })
                          console.log(fullItem17)
                          aux.push(fullItem17)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          console.log('ENTRADA')
                          if (response.data.invitation.temporalToken === '') {
                            var fullItem4 = Object.assign(item, { 'status': 2 })
                            var fullItem5 = Object.assign(fullItem4, { 'info': response.data })
                            console.log(fullItem5)
                            aux.push(fullItem5)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            localStorage.setItem('qr_code_temporal', message.data)
                            localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                            localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                            localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                            localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                            localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                            localStorage.setItem('host_street', response.data.invitation.street)
                            localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                            localStorage.setItem('host_supplier', response.data.invitation.supplier)
                            localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                            localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                            this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                          }
                        }
                      }
                    }
                  }
                  if (response.data.invitation.typeInv === 1) { // Tipo de Invitación Pre registro en Caseta
                    if (response2.data.length > 0 && response2.data[0].dateTime_EntranceAccess != null && response2.data[0].dateTime_ExitAccess != null) {
                      // alert('Ya se completó el acceso con la invitación Correspondiente.')
                      // this.head_color = 'orange display-1 text--primary'
                      // this.errores_guard = this.$t('mensaje_acceso_completo')
                      // this.dialog_errores = true
                      console.log('COMPLETO')
                      var fullItem44 = Object.assign(item, { 'status': 1 })
                      console.log(fullItem44)
                      aux.push(fullItem44)
                      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                    } else {
                      if (response2.data.length > 0) {
                        // this.entrada = false
                        // this.salida = true
                        // this.dialog = true
                        // this.activar_camara = false
                        console.log('SALIDA')
                        var fullItem222 = Object.assign(item, { 'status': 3 })
                        var fullItem333 = Object.assign(fullItem222, { 'info': response.data })
                        var fullItemAccess0 = Object.assign(fullItem333, { 'access': response2.data[0].id })
                        console.log(fullItemAccess0)
                        aux.push(fullItemAccess0)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var fechaLocal111 = new Date(this.get_current_date())
                        const readableDate = response.data.invitation.dateInv.substring(3, 6) + response.data.invitation.dateInv.substring(0, 2) + response.data.invitation.dateInv.substring(5, 10)
                        var fechaAccesoEntrada111 = new Date(readableDate)
                        if (fechaAccesoEntrada111.getTime() !== fechaLocal111.getTime()) {
                          console.log('Fuera de FECHA')
                          var fullItem177 = Object.assign(item, { 'status': 4 })
                          console.log(fullItem177)
                          aux.push(fullItem177)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          console.log('ENTRADA')
                          if (response.data.invitation.temporalToken === '') {
                            var fullItem41 = Object.assign(item, { 'status': 2 })
                            var fullItem51 = Object.assign(fullItem41, { 'info': response.data })
                            console.log(fullItem51)
                            aux.push(fullItem51)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            localStorage.setItem('qr_code_temporal', message.data)
                            localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                            localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                            localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                            localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                            localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                            localStorage.setItem('host_street', response.data.invitation.street)
                            localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                            localStorage.setItem('host_supplier', response.data.invitation.supplier)
                            localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                            localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                            this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                          }
                        }
                      }
                    }
                  }
                  if (response.data.invitation.typeInv === 2) { // Tipo de invitacion recurrente
                    if (response2.data.length === 0) {
                      var fechaLocal2 = new Date(this.get_current_date())
                      const readableDate = response.data.invitation.expiration.substring(3, 6) + response.data.invitation.expiration.substring(0, 2) + response.data.invitation.expiration.substring(5, 10)
                      var fechaExpiracion = new Date(readableDate)
                      console.log('FECHA DE EXPIRACION = ', fechaExpiracion.getTime())
                      console.log('FECHA ACTUAL = ', fechaLocal2)
                      console.log('FECHA DE EXPIRACION = ', response.data.invitation.expiration)
                      console.log('FECHA ACTUAL = ', fechaLocal2.getTime())
                      console.log('Día Actual = ', fechaLocal2.getDay())
                      console.log('Día Expiración = ', fechaExpiracion.getDay())
                      if (fechaLocal2.getDay() !== fechaExpiracion.getDay()) {
                        console.log('Día Diferente a la invitación recurrente.')
                      }
                      // if (fechaAccesoEntrada2.getTime() > fechaLocal2.getTime()) {
                      //   console.log('FECHA DE EXPIRACION > ACTUAL')
                      // }
                      // if (fechaAccesoEntrada2.getTime() < fechaLocal2.getTime()) {
                      //   console.log('FECHA DE EXPIRACION < ACTUAL')
                      // }
                      // if (fechaAccesoEntrada2.getTime() === fechaLocal2.getTime()) {
                      //   console.log('FECHA DE EXPIRACION = ACTUAL')
                      // }
                      if (fechaLocal2.getTime() > fechaExpiracion.getTime()) {
                        console.log('Expirada')
                        var fullItem18 = Object.assign(item, { 'status': 5 })
                        console.log(fullItem18)
                        aux.push(fullItem18)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var dias = response.data.invitation.diary
                        var diasJS = ['6', '0', '1', '2', '3', '4', '5']
                        console.log(dias)
                        console.log('Dia = ', diasJS[fechaLocal2.getDay()])
                        if (dias.includes(diasJS[fechaLocal2.getDay()]) === false) {
                          console.log('Día inválido')
                          var fullItem19 = Object.assign(item, { 'status': 6 })
                          console.log(fullItem19)
                          aux.push(fullItem19)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          console.log('ENTRADA RECURRENTE')
                          if (response.data.invitation.temporalToken === '') {
                            var fullItem6 = Object.assign(item, { 'status': 2 })
                            var fullItem7 = Object.assign(fullItem6, { 'info': response.data })
                            console.log(fullItem7)
                            aux.push(fullItem7)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            localStorage.setItem('qr_code_temporal', message.data)
                            localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                            localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                            localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                            localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                            localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                            localStorage.setItem('host_street', response.data.invitation.street)
                            localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                            localStorage.setItem('host_supplier', response.data.invitation.supplier)
                            localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                            localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                            this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                          }
                        }
                      }
                    } else {
                      if (response2.data[0].status === 1) {
                        // this.entrada = false
                        // this.salida = true
                        // this.dialog = true
                        // this.activar_camara = false
                        console.log('SALIDA RECURRENTE', response2.data[0])
                        var fullItem8 = Object.assign(item, { 'status': 3 })
                        var fullItem9 = Object.assign(fullItem8, { 'info': response.data })
                        var fullItemAccess2 = Object.assign(fullItem9, { 'access': response2.data[0].id })
                        console.log(fullItemAccess2)
                        aux.push(fullItemAccess2)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var fechaLocal = new Date(this.get_current_date())
                        const readableDate = response2.data[0].dateTime_EntranceAccess.substring(3, 6) + response2.data[0].dateTime_EntranceAccess.substring(0, 2) + response2.data[0].dateTime_EntranceAccess.substring(5, 10)
                        const expirationDate = response.data.invitation.expiration.substring(3, 6) + response.data.invitation.expiration.substring(0, 2) + response.data.invitation.expiration.substring(5, 10)
                        var fechaAccesoEntrada = new Date(readableDate)
                        var expirationDate2 = new Date(expirationDate)
                        console.log('FECHA DE EXPIRACION = ', expirationDate2.getTime())
                        console.log('FECHA ACTUAL = ', fechaLocal)
                        console.log('FECHA DE EXPIRACION = ', response.data.invitation.expiration)
                        console.log('FECHA ACTUAL = ', fechaLocal.getTime())
                        console.log('Día Actual = ', fechaLocal.getDay())
                        console.log('Día Expiración = ', expirationDate2.getDay())
                        if (fechaLocal.getDay() !== expirationDate2.getDay()) {
                          console.log('Día Diferente a la invitación recurrente.')
                        }
                        if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                          if (fechaLocal.getTime() > expirationDate2.getTime()) {
                            console.log('Expirada')
                            var fullItem20 = Object.assign(item, { 'status': 5 })
                            console.log(fullItem20)
                            aux.push(fullItem20)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            dias = response.data.invitation.diary
                            diasJS = ['6', '0', '1', '2', '3', '4', '5']
                            console.log(dias)
                            console.log('Dia = ', diasJS[fechaLocal.getDay()])
                            if (dias.includes(diasJS[fechaLocal.getDay()]) === false) {
                              console.log('Día inválido')
                              var fullItem21 = Object.assign(item, { 'status': 6 })
                              console.log(fullItem21)
                              aux.push(fullItem21)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            } else {
                              console.log('ENTRADA RECURRENTE')
                              var fullItem22 = Object.assign(item, { 'status': 2 })
                              var fullItem23 = Object.assign(fullItem22, { 'info': response.data })
                              console.log(fullItem23)
                              aux.push(fullItem23)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            }
                          }
                        } else {
                          // this.clear_without_activate_camera()
                          // this.head_color = 'orange display-1 text--primary'
                          // this.errores_guard = this.$t('mensaje_acceso_completo')
                          // this.dialog_errores = true
                          console.log('COMPLETO RECURRENTE')
                          var fullItem10 = Object.assign(item, { 'status': 1 })
                          var fullItem11 = Object.assign(fullItem10, { 'info': response.data })
                          console.log(fullItem11)
                          aux.push(fullItem11)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        }
                      }
                    }
                  }
                }).catch(error => {
                  console.log(error)
                })
                break
              case 1: // Residente
                console.log('Residente')
                var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                var item = message
                var fullItem13 = Object.assign(item, { 'info': response.data })
                var fullItem14 = Object.assign(fullItem13, { 'status': -1 })
                console.log(fullItem14)
                aux.push(fullItem14)
                localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                break
              case 2: // Worker
                const config3 = {
                  method: 'post',
                  url: 'https://clubtest.intrare.app/WorkerAccess/Status/',
                  headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                  },
                  data: {
                    'qr_code': message.data
                  }
                }
                axios(config3)
                  .then(response3 => {
                    console.log(response3.data.status)
                    var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                    var item = message
                    switch (response3.data.status) {
                      case 10:
                        var fullItem15 = Object.assign(item, { 'info': response.data })
                        var fullItem16 = Object.assign(fullItem15, { 'status': 10 })
                        console.log(fullItem16)
                        aux.push(fullItem16)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                      case 11:
                        var fullItem17 = Object.assign(item, { 'info': response.data })
                        var fullItem18 = Object.assign(fullItem17, { 'status': 11 })
                        console.log(fullItem18)
                        aux.push(fullItem18)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                      case 12:
                        var fullItem19 = Object.assign(item, { 'status': 12 })
                        console.log(fullItem19)
                        aux.push(fullItem19)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                      case 13:
                        var fullItem20 = Object.assign(item, { 'status': 13 })
                        console.log(fullItem20)
                        aux.push(fullItem20)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                    }
                  })
                  .catch(error => {
                    console.log(error)
                  })
                break
            }
          }).catch(error => {
            console.log(error)
            if (error.request.status === 404) {
              console.log('NO Valido')
              var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var item = message
              var fullItem12 = Object.assign(item, { 'status': 0 })
              console.log(fullItem12)
              aux.push(fullItem12)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
            if (error.request.status === 401) {
              console.log('Invitacion Expirada')
              var listQrCodesAux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var itemAux = message
              var fullItemAux = Object.assign(itemAux, { 'status': 5 })
              console.log(fullItemAux)
              listQrCodesAux.push(fullItemAux)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
            if (error.request.status === 403) {
              console.log('Invitacion Cancelada')
              var listQrCodesAux2 = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var itemAux2 = message
              var fullItemAux2 = Object.assign(itemAux2, { 'status': -3 })
              console.log(fullItemAux2)
              listQrCodesAux2.push(fullItemAux2)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux2))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
            if (error.request.status === 423) {
              console.log('Modo Vacaciones Aactivado')
              var listQrCodesAux3 = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var itemAux3 = message
              var fullItemAux3 = Object.assign(itemAux3, { 'status': -5 })
              console.log(fullItemAux3)
              listQrCodesAux3.push(fullItemAux3)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux3))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
          })
          if (localStorage.getItem('qr_devices') !== null) {
            console.log('Dato recivido de QR')
            let band = false
            let devicesAux = JSON.parse(localStorage.getItem('qr_devices'))
            console.log('Auxiluar = ', devicesAux)
            for (let i = 0; !band && i < devicesAux.length; i++) {
              if (devicesAux[i].label === message.label) {
                console.log(devicesAux[i].label, '===', message.label)
                devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                localStorage.setItem('qr_devices', JSON.stringify(devicesAux))
                this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
                band = true
              }
            }
            console.log(JSON.parse(localStorage.getItem('qr_devices')))
          }
          break
        case 'cam':
          if (localStorage.getItem('banderaAdditionalPerson') !== null || localStorage.getItem('banderaINEBack') !== null) {
            console.log('banderaAdditionalPerson', localStorage.getItem('banderaAdditionalPerson'))
            console.log('banderaINEBack', localStorage.getItem('banderaINEBack'))
            if (localStorage.getItem('banderaAdditionalPerson') === 'true') {
              console.log('Foto Additional Person')
              var auxAdditional = localStorage.getItem('listStorePhotosCameraAdditionalPerson') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson'))
              while (auxAdditional.length > 0) {
                auxAdditional.pop()
              }
              auxAdditional.push(message)
              localStorage.setItem('listStorePhotosCameraAdditionalPerson', JSON.stringify(auxAdditional))
              this.$store.commit('setPhotosAdditionalPerson', JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson')))
              if (localStorage.getItem('cam_devices') !== null) {
                console.log('Dato recivido de CAM')
                let band = false
                let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                console.log('Auxiluar = ', devicesAux)
                for (let i = 0; !band && i < devicesAux.length; i++) {
                  if (devicesAux[i].label === message.label) {
                    console.log(devicesAux[i].label, '===', message.label)
                    devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                    localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                    this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                    band = true
                  }
                }
                console.log(JSON.parse(localStorage.getItem('cam_devices')))
              }
            } else {
              if (localStorage.getItem('banderaINEBack') === 'true') {
                console.log('Foto INE Back')
                var auxAdditional2 = localStorage.getItem('listStorePhotosCameraINEBack') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack'))
                while (auxAdditional2.length > 0) {
                  auxAdditional2.pop()
                }
                auxAdditional2.push(message)
                localStorage.setItem('listStorePhotosCameraINEBack', JSON.stringify(auxAdditional2))
                this.$store.commit('setPhotosINEBack', JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')))
                if (localStorage.getItem('cam_devices') !== null) {
                  console.log('Dato recivido de CAM')
                  let band = false
                  let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                  console.log('Auxiluar = ', devicesAux)
                  for (let i = 0; !band && i < devicesAux.length; i++) {
                    if (devicesAux[i].label === message.label) {
                      console.log(devicesAux[i].label, '===', message.label)
                      devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                      localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                      this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                      band = true
                    }
                  }
                  console.log(JSON.parse(localStorage.getItem('cam_devices')))
                }
              } else {
                console.log('Foto Normal')
                var aux = localStorage.getItem('listStorePhotosCamera') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCamera'))
                while (aux.length > 0) {
                  aux.pop()
                }
                aux.push(message)
                localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
                this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
                if (localStorage.getItem('cam_devices') !== null) {
                  console.log('Dato recivido de CAM')
                  let band = false
                  let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                  console.log('Auxiluar = ', devicesAux)
                  for (let i = 0; !band && i < devicesAux.length; i++) {
                    if (devicesAux[i].label === message.label) {
                      console.log(devicesAux[i].label, '===', message.label)
                      devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                      localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                      this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                      band = true
                    }
                  }
                  console.log(JSON.parse(localStorage.getItem('cam_devices')))
                }
              }
            }
          }
          break
      }
      console.log('Dato Recivido: ', message)
    },
    onError (event) {
      console.log('An error occured:', event.data)
    },
    get_current_date () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    },
    getAreaStatusColor (status) {
      switch (status) {
        case 'low': return 'green'
        case 'medium': return 'orange'
        case 'high': return 'red'
        default: return 'grey'
      }
    },
    getAreaStatusIcon (status) {
      switch (status) {
        case 'low': return 'mdi-check-circle'
        case 'medium': return 'mdi-alert-circle'
        case 'high': return 'mdi-alert'
        default: return 'mdi-help-circle'
      }
    },
    getAreaStatusLabel (status) {
      switch (status) {
        case 'low': return this.$t('occupancy_low') || 'Baja'
        case 'medium': return this.$t('occupancy_medium') || 'Media'
        case 'high': return this.$t('occupancy_high') || 'Alta'
        default: return 'Desconocido'
      }
    },
    getMdiIcon (iconString) {
      if (!iconString) return 'mdi-map-marker-radius'
      if (iconString.includes('mdi-')) return iconString

      const lowerIcon = iconString.toLowerCase().trim()

      const map = {
        'fitness_center': 'mdi-dumbbell',
        'gym': 'mdi-dumbbell',
        'gimnasio': 'mdi-dumbbell',
        'pool': 'mdi-pool',
        'natacion': 'mdi-pool',
        'natación': 'mdi-pool',
        'alberca': 'mdi-pool',
        'piscina': 'mdi-pool',
        'swim': 'mdi-pool',
        'sports_tennis': 'mdi-tennis',
        'tennis': 'mdi-tennis',
        'sports_soccer': 'mdi-soccer',
        'soccer': 'mdi-soccer',
        'sports_basketball': 'mdi-basketball',
        'basketball': 'mdi-basketball',
        'sports_golf': 'mdi-golf',
        'golf': 'mdi-golf',
        'spa': 'mdi-spa',
        'restaurant': 'mdi-silverware'
      }

      return map[lowerIcon] || 'mdi-' + lowerIcon.replace(/_/g, '-')
    },
    getAreaStatusHex (status) {
      switch (status) {
        case 'low': return '#4CAF50'
        case 'medium': return '#FB8C00'
        case 'high': return '#F44336'
        default: return '#9E9E9E'
      }
    },
    async loadTeacherData () {
      this.loadingTeacherData = true
      try {
        const config = {
          method: 'get',
          url: 'https://clubtest.intrare.app/staff/my-areas/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.getProfile.language || 'es',
            'authorization': 'Token ' + store.getters.getToken
          }
        }

        const response = await axios(config)

        // Handle single area or array
        let area = Array.isArray(response.data) ? response.data[0] : response.data

        if (area) {
          this.teacherArea = area
          // Load occupancy for this area
          await this.loadTeacherAreaOccupancy(area.idArea)
        }
      } catch (error) {
        console.error('Error loading teacher data:', error)
      } finally {
        this.loadingTeacherData = false
      }
    },
    async loadTeacherAreaOccupancy (areaId) {
      try {
        const config = {
          method: 'get',
          url: `https://clubtest.intrare.app/area/${areaId}/occupancy/`,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.getProfile.language || 'es',
            'authorization': 'Token ' + store.getters.getToken
          }
        }

        const response = await axios(config)
        this.teacherOccupancy = response.data
      } catch (error) {
        console.error('Error loading teacher area occupancy:', error)
      }
    },
    goToArea (area) {
      if (area && area.area_id) {
        this.$router.push({ name: 'area_checkin', params: { areaId: area.area_id } })
      }
    },
    async loadHandicapData () {
      if (!this.isGolfUser) return

      this.handicapLoading = true
      try {
        const handicapModule = this.$store.state.handicap
        if (handicapModule && handicapModule.myHandicap) {
          this.myHandicap = {
            value: handicapModule.myHandicap,
            lastUpdate: new Date()
          }
          this.clubAverage = handicapModule.clubAverage || 12.5
        } else {
          this.myHandicap = { value: '--' }
          this.clubAverage = '--'
        }
      } catch (error) {
        console.error('Error loading handicap data:', error)
        this.myHandicap = { value: '--' }
        this.clubAverage = '--'
      } finally {
        this.handicapLoading = false
      }
    },
    async loadUpcomingReservationsWithAgreement () {
      if (!this.isGolfUser) return

      this.upcomingReservationsLoading = true
      try {
        const courseAgreements = this.$store.state.courseAgreements?.agreements || []
        const agreements = courseAgreements.filter(a => a.is_active)

        if (agreements.length === 0) {
          this.upcomingReservationsWithAgreement = []
          return
        }

        const agreementCourses = agreements.map(a => a.name)

        const golfReservations = this.$store.state.golf?.reservations || []
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        this.upcomingReservationsWithAgreement = golfReservations
          .filter(r => {
            const resDate = new Date(r.date_played)
            resDate.setHours(0, 0, 0, 0)
            return resDate >= today && agreementCourses.includes(r.course_name)
          })
          .map(r => {
            const agreement = agreements.find(a => a.name === r.course_name)
            return {
              ...r,
              agreement_type: this.getAgreementTypeLabel(agreement?.agreement_type)
            }
          })
          .sort((a, b) => new Date(a.date_played) - new Date(b.date_played))
          .slice(0, 5)
      } catch (error) {
        console.error('Error loading upcoming reservations:', error)
        this.upcomingReservationsWithAgreement = []
      } finally {
        this.upcomingReservationsLoading = false
      }
    },
    getAgreementTypeLabel (typeId) {
      const types = {
        1: 'Pago',
        2: 'Cortesía',
        3: 'Intercambio',
        4: 'Privilegio',
        5: 'Especial'
      }
      return types[typeId] || 'Convenio'
    },
    formatDate (date) {
      if (!date) return '--'
      return new Date(date).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  position: relative;
  min-height: 100vh;
}

.dashboard-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.dashboard-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1600px;
  margin: 0 auto;
}

.dashboard-card {
  background: rgba(255, 255, 255, 0.95) !important;
}

.dashboard-row {
  width: 100%;
}

.area-occ-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12) !important;
  transform: translateY(-2px);
}

.chart-container {
  height: 300px;
  position: relative;
}

.chart-container-small {
  height: 180px;
  position: relative;
}

.occupancy-item {
  padding: 8px 0;
}

.occupancy-label {
  white-space: nowrap;
  font-size: 14px;
  margin-right: 16px;
}

.filter-toggle .v-btn--active {
  background-color: #2a2738 !important;
  color: white !important;
}

.filter-toggle .v-btn--active .v-btn__content {
  color: white !important;
}

/* Responsividad */
@media (max-width: 600px) {
  .occupancy-item {
    padding: 6px 0;
  }

  .occupancy-label {
    font-size: 12px;
    margin-right: 8px;
  }

  .chart-container {
    height: 250px;
  }

  .filter-btn {
    padding: 0 8px !important;
    font-size: 11px !important;
  }
}

@media (max-width: 960px) {
  .dashboard-content h1 {
    font-size: 1.5rem;
  }
}
</style>
